import { Controller } from "@hotwired/stimulus"
import "../theme/bootstrap-timepicker"

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || '';

export default class TimepickerController extends Controller {
    connect() {
        const $input = $(this.element);
        $input.timepicker({
            showInputs: false,
            minuteStep: 1,
            defaultTime: null,
            icons: {
              up: 'fas fa-chevron-up',
              down: 'fas fa-chevron-down'
            },
            appendWidgetTo: $input.closest('.timepicker-container'),
        }).on('changeTime.timepicker', function () {
            let event = new Event('change', { bubbles: true });
            this.dispatchEvent(event);
            $(this).valid();
        });
        
        const label = document.querySelector(`label[for="${this.element.id}"]`);
        if (label) {
            label.addEventListener('click', (e) => {
                $input.timepicker('showWidget');
            });
        }

        if (this.element.classList.contains('broadcast_date')) {
            // Add the blur event handler to call a function after the field loses focus
            $input.on('blur', function () {
                setTimeout(() => {
                    event_date_time_change();
                }, 5000);
            });
        }
        this.preventAutoClose($input);
    }

    preventAutoClose($input) {
        const widgetSelector = '.bootstrap-timepicker-widget';
        let isTouchScrolling = false;

        globalThis.addEventListener('touchmove', () => {
            isTouchScrolling = true;
        });

        globalThis.addEventListener('touchend', () => {
            if (isTouchScrolling && document.activeElement === $input[0]) {
                    if (!$(widgetSelector).is(':visible')) {
                        $input.timepicker('showWidget');
                    }
            }
            isTouchScrolling = false;
        });
    }
}

// Define your custom method
function event_date_time_change() {
    let start_date = $('.broadcast_start_date').val()
    let start_time = $('.broadcast_start_time').val()
    let end_date = $('.broadcast_end_date').val()
    let end_time = $('.broadcast_end_time').val()
    if ((start_date && start_time) || (end_date && end_time)) {
        let data = {date: start_date || end_date, time: start_time || end_time}
        fetch("/users/tv_broadcast_shows/find_event_time", {
            method: 'post',
            headers: {
                "X-CSRF-Token": csrfToken,
                'Content-Type': 'application/json',
                Accept: "text/vnd.turbo-stream.html"
            }, body: JSON.stringify(data)
        }).then(r => r.text(
        )).then(html => {
            Turbo.renderStreamMessage(html);
        })
    }
}
